<template>
  <LayoutPage :title="t('title')">
    <i18n-t
      tag="h1"
      :keypath="error.headingKey"
      class="text-primary-600 text-xl"
    />

    <div class="grid gap-2">
      <i18n-t tag="div" :keypath="error.messageKey" />
      <i18n-t tag="div" :keypath="error.instructionsKey">
        <!--suppress VueUnrecognizedSlot -->
        <template #merchant>
          {{ merchantName }}
        </template>
      </i18n-t>
    </div>

    <slot name="details">
      <ErrorDetails :error="error" />
    </slot>
  </LayoutPage>
</template>

<script setup lang="ts">
  import {
    useMerchantName,
    useUserFriendlyError,
  } from "@versatile-credit-apply/composition"
  import { ErrorDetails } from "@versatile-credit-apply/components"
  import { useI18n } from "vue-i18n"
  import { toRef } from "vue"

  interface Props {
    error?: unknown
  }

  const props = defineProps<Props>()

  defineSlots<{
    details: never
  }>()

  const { t } = useI18n()
  const merchantName = useMerchantName()

  const error = useUserFriendlyError({
    error: toRef(props, "error"),
  })
</script>

<i18n lang="yaml" locale="en">
errors:
  general:
    heading: Something went wrong
    instructions:
      at_home: Please try again later.
      in_store: Please see your {merchant} associate for assistance.
    message:
      user: We’re having some technical trouble on our end.

title: Error
</i18n>
